export type RouteAccessInput = {
  requiresAuth: boolean
  isLoginRoute: boolean
  fullPath: string
  authenticated: boolean
}

export function routeAccessDecision(input: RouteAccessInput) {
  if (input.requiresAuth && !input.authenticated) {
    return { name: 'login', query: { redirect: input.fullPath } }
  }
  if (input.isLoginRoute && input.authenticated) return { name: 'me' }
  return true
}
